import { combineReducers } from 'redux';

import list from './meta-sites/list';
import details from './meta-sites/details';
import apps from './meta-sites/apps';
import permissions from './permissions';

export interface MetaSitesState {
  metaSites: {
    list: ReturnType<typeof list>
    details: ReturnType<typeof details>
    apps: ReturnType<typeof apps>
    permissions: ReturnType<typeof permissions>
  }
}

export * from './meta-sites/details';

export default combineReducers({
  permissions,
  list,
  details,
  apps,
});
